import './drawerComponent.scss'
import {Drawer} from "@material-ui/core";

import React, {useCallback} from 'react';
import ButtonComponent from "../core/button/ButtonComponent";
import CloseIcon from "@mui/icons-material/Close";

interface DrawerComponentProps {
    title?: string;
    onClose?: (reason: string) => void;
    className?: string;
    direction?: 'bottom' | 'left' | 'right' | 'top';
    variant?: 'permanent' | 'persistent' | 'temporary';
    open?: boolean;
    hideBackdrop?: boolean;
    closeOnEsc?: boolean;
    closeOnBackDropClick?: boolean;
}

const DrawerComponent = (props: React.PropsWithChildren<DrawerComponentProps>) => {

        let {
            direction,
            className,
            title,
            onClose,
            variant,
            open,
            children,
            hideBackdrop,
        } = props;

        const closeOnEsc = props.closeOnEsc !== undefined ? props.closeOnEsc : true;
        const closeOnBackDropClick = props.closeOnBackDropClick !== undefined ? props.closeOnBackDropClick : true;

        if (!open) open = false;
        if (!direction) direction = "right";
        if (!variant) variant = "temporary";

        const handleClose = useCallback((event: any, reason: string) => {
            if(reason === "backdropClick" && !closeOnBackDropClick){
                return;
            }
            if(reason === "escapeKeyDown" && !closeOnEsc){
                return;
            }
            if (onClose) {
                onClose(reason);
            }
        }, [closeOnBackDropClick, closeOnEsc,onClose]);

        return (
            <div className={'drawer-component'}>
                <Drawer
                    open={open}
                    disableEnforceFocus
                    variant={variant}
                    onClose={handleClose}
                    hideBackdrop={hideBackdrop}
                    transitionDuration={300}
                    anchor={direction}
                    className={"t-drawer " + className}
                >
                    <div className="drawer-header">
                        <div className="drawer-title">
                            {title && title}
                        </div>
                        <div className="drawer-options">
                            {
                                onClose && <ButtonComponent variant={"icon"}
                                                            handleClick={handleClose}
                                                            color={'secondary'}
                                                            data-testid={"close-button"}
                                >
                                    <CloseIcon/>
                                </ButtonComponent>
                            }
                        </div>
                    </div>
                    <div className="drawer-body">
                        {children}
                    </div>
                </Drawer>
            </div>

        )
    }

;

export default DrawerComponent;